import ScrollReveal from '@/components/base/ScrollReveal';
import AnimatedCounter from '@/components/base/AnimatedCounter';

const stats = [
  {
    icon: 'ri-user-star-line',
    value: 1500,
    suffix: '+',
    label: 'Clientes satisfechos',
    description: 'Personas y empresas que ya confían en nosotros',
    color: 'accent',
  },
  {
    icon: 'ri-bank-line',
    value: 50,
    suffix: 'M+',
    label: 'En créditos otorgados',
    description: 'Millones de pesos impulsando el crecimiento',
    color: 'primary',
  },
  {
    icon: 'ri-building-line',
    value: 50,
    suffix: '+',
    label: 'PyMEs financiadas',
    description: 'Empresas que crecen con nuestro respaldo',
    color: 'accent',
  },
  {
    icon: 'ri-timer-flash-line',
    value: 48,
    suffix: 'h',
    label: 'Tiempo promedio de entrega',
    description: 'Del envío de documentos al depósito en tu cuenta',
    color: 'primary',
  },
];

export default function Stats() {
  return (
    <section id="impacto" className="relative py-20 md:py-28 overflow-hidden" style={{ background: 'oklch(var(--background-50))' }}>
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent 0%, oklch(var(--accent-500) / 0.25) 30%, oklch(var(--accent-500) / 0.45) 50%, oklch(var(--accent-500) / 0.25) 70%, transparent 100%)' }}></div>
        <div className="absolute bottom-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent 0%, oklch(var(--accent-500) / 0.15) 50%, transparent 100%)' }}></div>

        <div className="absolute top-[-10%] right-[-5%] w-[450px] h-[450px] rounded-full opacity-[0.06]" style={{ background: 'radial-gradient(circle, oklch(var(--accent-500)) 0%, transparent 60%)' }}></div>
        <div className="absolute bottom-[-15%] left-[-5%] w-[500px] h-[500px] rounded-full opacity-[0.04]" style={{ background: 'radial-gradient(circle, oklch(var(--accent-400)) 0%, transparent 60%)' }}></div>

        <svg className="absolute top-1/2 left-0 -translate-y-1/2 w-full h-32 opacity-[0.05]" xmlns="http://www.w3.org/2000/svg">
          <line x1="0" y1="15" x2="100%" y2="15" stroke="oklch(var(--accent-500))" strokeWidth="0.5" strokeDasharray="3 12" />
          <line x1="0" y1="55" x2="100%" y2="55" stroke="oklch(var(--accent-500))" strokeWidth="0.5" strokeDasharray="6 18" />
          <line x1="0" y1="95" x2="100%" y2="95" stroke="oklch(var(--accent-500))" strokeWidth="0.5" strokeDasharray="2 8" />
        </svg>
      </div>

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10">
        <ScrollReveal animation="fade-up" duration={600}>
          <div className="text-center mb-16">
            <span className="inline-block text-accent-600 text-sm font-semibold tracking-widest uppercase mb-3">Nuestro impacto</span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              Resultados que <span className="text-accent-600">hablan</span> por sí solos
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <ScrollReveal key={stat.label} animation="fade-up" delay={index * 120} duration={700}>
              <div
                className="relative group p-8 rounded-3xl transition-all duration-500 hover:scale-[1.03] overflow-hidden"
                style={{
                  background: 'oklch(var(--background-50))',
                  border: '1px solid oklch(var(--background-200))',
                }}
              >
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                  style={{
                    background: stat.color === 'accent'
                      ? 'radial-gradient(ellipse at 50% 0%, oklch(var(--accent-500) / 0.06) 0%, transparent 70%)'
                      : 'radial-gradient(ellipse at 50% 0%, oklch(var(--primary-300) / 0.06) 0%, transparent 70%)',
                  }}
                ></div>

                <div className="relative z-10">
                  <div
                    className="w-14 h-14 rounded-2xl flex items-center justify-center mb-6 transition-all duration-500 group-hover:scale-110 group-hover:rotate-3"
                    style={{
                      background: stat.color === 'accent'
                        ? 'oklch(var(--accent-500) / 0.10)'
                        : 'oklch(var(--primary-300) / 0.10)',
                    }}
                  >
                    <i
                      className={`${stat.icon} text-2xl transition-colors duration-500`}
                      style={{ color: stat.color === 'accent' ? 'oklch(var(--accent-600))' : 'oklch(var(--primary-500))' }}
                    ></i>
                  </div>

                  <AnimatedCounter
                    end={stat.value}
                    suffix={stat.suffix}
                    className="block text-3xl md:text-4xl font-bold text-foreground-950 mb-2"
                    duration={2200}
                  />

                  <div className="text-foreground-700 text-sm font-semibold mb-1.5" style={{ fontFamily: 'var(--font-heading)' }}>
                    {stat.label}
                  </div>
                  <div className="text-foreground-500 text-xs leading-relaxed">
                    {stat.description}
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}